export default __webpack_public_path__ + "static/media/portfolio-218.f84a4f94.jpg";